import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";
import UserTypeView from "@/views/signup/UserTypeView.vue";
import TermsConditionsView from "@/views/signup/TermsConditionsView.vue";
import TotalUserDetailView from "@/views/signup/TotalUserDetailView.vue";
import CertificateRegistrationView from "@/views/signup/CertificateRegistrationView.vue";
import CertificateApprovalView from "@/views/signup/CertificateApprovalView.vue";
import authModal from "@/components/popup/authModal.vue";
import { Member, saveFile } from "@/common/types";
import userAPI from "@/api/userAPI";
import { onBeforeRouteLeave } from "vue-router";



export default /*@__PURE__*/_defineComponent({
  __name: 'SignupView',
  setup(__props) {

const step = ref(1);
const member = ref<Member>({
  회원순번: 0,
  회원아이디: new Date().toISOString().slice(8, 14).replace("T", ""),
  비밀번호: new Date().toISOString().slice(8, 14).replace("T", ""),
  사업자구분: "",
  사업자번호: "",
  사업자명: "",
  대표자명: "",
  대표자전화번호: "",
  담당자명: "",
  담당자전화번호: "",
  담당자이메일: "",
  우편번호: "",
  주소: "",
  상세주소: "",
  우편번호2: "",
  주소2: "",
  상세주소2: "",
  회원구분: "",
  비고: "",
  회원연혁: "",
  수주수행구분: "",
  사업자등록증: {} as saveFile,
})
const fileData = ref<File | null>(null);
onMounted(() => {
  const date = new Date()
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');

  member.value.회원아이디 = dd + "" + hh + mm
  member.value.비밀번호 = dd + "" + hh + mm

})
onBeforeRouteLeave((to, from, next) => {
  if(to.name != "singup") {
    next()
  } else {
    if (step.value > 1 && step.value < 5) {
      next(false);
      pervStep()
      // 실행시킬 함수 추가
    } else {
      next();
    }
  }
});
const setType = (type:string) => {
  member.value.회원구분 = type;
  nextStep();
}
const setConsent = () => {
    nextStep();
}
const setUser = async(data:any) => {
  
  const businessNumber = `${data.businessNumber1}-${data.businessNumber2}-${data.businessNumber3}`.replaceAll("-", "");
  const phoneNumber = `${data.phoneNumber1}-${data.phoneNumber2}-${data.phoneNumber3}`.replaceAll("-", "");
  const managerPhone = `${data.managerPhone1}-${data.managerPhone2}-${data.managerPhone3}`.replaceAll("-", "");
  const email = `${data.email1}@${data.email2}`;
  member.value = {
    ...member.value,
    사업자구분: data.businessType,
    사업자명: data.companyName,
    사업자번호: businessNumber,
    대표자명: data.representativeName,
    대표자전화번호: phoneNumber,
    담당자명: data.managerName,
    담당자전화번호: managerPhone,
    담당자이메일: email,
    우편번호: data.companyAddress1,
    주소: data.companyAddress2,
    상세주소: data.addressDetail,
    우편번호2: data.companyAddress21,
    주소2: data.companyAddress22,
    상세주소2: data.addressDetail2,
    비고: data.remarks,
  }
  fileData.value = data.file;
  
  nextStep();
}
const authFlag = ref(false);
const close = (flag: boolean) => {
  if(flag) {
    setJoin()
  }
  authFlag.value = false;
}
const authJoin = () => {
  authFlag.value = true;
}
const setJoin = async() => {
  
  const formData = new FormData();
  formData.append(
    "data",
    new Blob(
      [
        JSON.stringify(member.value),
      ],
      { type: "application/json" }
    )
  );

  if (fileData.value) {
    formData.append("사업자등록증", fileData.value);
  }

  await userAPI
    .signUp(formData)
    .then((res) => {
      if (res.data.success) {
        alert("회원가입이 성공적으로 완료되었습니다!");
      }
    })
    .catch((error) => {
      console.error("회원가입 오류:", error);
    });
    nextStep();
}
const nextStep = () => {
  console.log(member.value.회원아이디)
  step.value += 1;
  document.getElementsByClassName('contents')[0].scrollTo(0, 0);
}
const pervStep = () => {
  step.value -= 1;
  document.getElementsByClassName('contents')[0].scrollTo(0, 0);
  if(step.value == 1) {
    member.value.회원구분 = "";
  }
  if(step.value == 2) {
    fileData.value = null;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (step.value == 1)
      ? (_openBlock(), _createBlock(UserTypeView, {
          key: 0,
          onSetType: setType
        }))
      : _createCommentVNode("", true),
    (step.value == 2)
      ? (_openBlock(), _createBlock(TermsConditionsView, {
          key: 1,
          회원구분: member.value.회원구분,
          onSetConsent: setConsent
        }, null, 8, ["회원구분"]))
      : _createCommentVNode("", true),
    (step.value == 3)
      ? (_openBlock(), _createBlock(TotalUserDetailView, {
          key: 2,
          member: member.value,
          회원구분: member.value.회원구분,
          onSetUser: setUser
        }, null, 8, ["member", "회원구분"]))
      : _createCommentVNode("", true),
    (step.value == 4)
      ? (_openBlock(), _createBlock(CertificateRegistrationView, {
          key: 3,
          onSetJoin: _cache[0] || (_cache[0] = ($event: any) => (authJoin()))
        }))
      : _createCommentVNode("", true),
    (step.value == 5)
      ? (_openBlock(), _createBlock(CertificateApprovalView, { key: 4 }))
      : _createCommentVNode("", true),
    (authFlag.value)
      ? (_openBlock(), _createBlock(authModal, {
          key: 5,
          onClose: close,
          businessno: member.value.사업자번호
        }, null, 8, ["businessno"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})